/**
 * Branding & contact info for the Axon Muscle Affiliate Program.
 *
 * Kept tiny on purpose — this is the only "data" the affiliate site needs.
 */

export const BRAND = {
  name: 'Axon Muscle',
  tagline: 'Affiliate Program',
  programLine: 'Earn with Axon Muscle — Launch Your Own Fitness Store in Minutes',
  parentDomain: 'axonmuscle.com',
};

export const CONTACT_INFO = {
  email: 'contact@axonmuscle.com',
  phone: '(833) 631-4657',
  address: {
    street: '460 NE 28th St',
    city: 'Miami',
    state: 'FL',
    zip: '33137',
    country: 'United States',
  },
};
